export default __webpack_public_path__ + "static/media/card1.6f251a79.jpeg";